import { render } from "./collection-doorways.vue?vue&type=template&id=0c9a59d0"
import script from "./collection-doorways.vue?vue&type=script&lang=js"
export * from "./collection-doorways.vue?vue&type=script&lang=js"

import "./collection-doorways.vue?vue&type=style&index=0&id=0c9a59d0&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__